export default __webpack_public_path__ + "static/media/pergola_6_1.999ef6ad.png";